// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3tvYo","itemTitle":"ClientEmergencyInfo_itemTitle__3E10u","itemText":"ClientEmergencyInfo_itemText__3awIE"};